import React from "react";

import { useUser } from "@components/user-context";
import { type DataTypeProvider } from "@devexpress/dx-react-grid";
import { formatting } from "@north-beam/nb-common";

import { calculateAverageSpendOnCompletedWeeks } from "../../utils/calculate_average_spend_to_date";
import { type TableRowType } from "../performance-tracking-table";

export const AvgWeeklySpendDataFormatter = ({
  value,
  row: _row,
}: DataTypeProvider.ValueFormatterProps) => {
  const { user } = useUser();
  const row = _row as TableRowType;

  const { weeklyMetrics } = row.data;

  const avgWeeklyBudgeted =
    weeklyMetrics.reduce((acc, { budgeted }) => acc + (budgeted ?? 0), 0) /
    weeklyMetrics.length;

  const avgWeeklySpend = calculateAverageSpendOnCompletedWeeks(weeklyMetrics);

  return (
    <div className="flex justify-center space-x-2 items-center h-full p-2 text-right overflow-hidden">
      <div className="text-gray+1 font-medium text-sm font-mono">
        {formatting.formatCurrency(avgWeeklyBudgeted, {
          precision: "approximate",
          code: user.currencies.currentCurrency,
        })}
      </div>
      <div className="pr-1 text-gray text-md font-medium">|</div>
      <div className="text-cosmic font-medium text-sm font-mono">
        {formatting.formatCurrency(avgWeeklySpend, {
          precision: "approximate",
          code: user.currencies.currentCurrency,
        })}
      </div>
    </div>
  );
};
